import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  DialogTitle,
  IconButton,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../../../../../views/components/common/form/CustomTypography";
import AppButton from "../../../../../../views/components/common/buttons/AppButton";
import CustomTextField from "../../../../../../views/components/common/textFields/TextField";

interface SendNpsPopupProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (name: string, email: string) => void;
}

const SendNpsPopup: React.FC<SendNpsPopupProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const theme = useTheme();
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");

  const handleSubmit = () => {
    onSubmit(name, email);
    setName("");
    setEmail("");
  }

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 3,
          pb: 2,
          pt: 2,
        }}
      >
        <CustomTypography variant="heading5" fontWeight={600}>
          Add the following details to proceed further
        </CustomTypography>
        <IconButton
          sx={{ left: "12px" }}
          aria-label="close"
          onClick={() => {
            onClose();
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box
          display={{
            md: "flex",
            xl: "flex",
            lg: "flex",
            sm: "block",
            xs: "block",
          }}
          justifyContent={"space-between"}
        >
          <Box flex={1}>
            <Box>
              <CustomTypography
                variant="body1"
                fontWeight={500}
                style={{
                  color: theme.palette.customColors.greyTextColor,
                  marginBottom: 6,
                }}
              >
                Name (Optional)
              </CustomTypography>
              <CustomTextField
                placeholder="Please add name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Box>
          </Box>
          <Box
            flex={1}
            mt={{ sm: 2, xs: 2, md: 0, xl: 0, lg: 0 }}
            display={"flex"}
            justifyContent={{
              md: "end",
              xl: "end",
              lg: "end",
              sm: "start",
              xs: "start",
            }}
          >
            <Box>
              <CustomTypography
                variant="body1"
                fontWeight={500}
                style={{
                  color: theme.palette.customColors.greyTextColor,
                  marginBottom: 6,
                }}
              >
                Email (Optional)
              </CustomTypography>
              <CustomTextField
                placeholder="Please add email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pb: 2, pt: 2 }}>
        <AppButton onClick={onClose} variant="grayscale" label={"Cancel"} />
        <AppButton
          onClick={() => handleSubmit()}
          variant="primary"
          label={"Save"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default SendNpsPopup;
